export enum HsaClassificationJobStatus {
  Queued = "queued",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
  PausedBudget = "paused_budget",
}
